module.exports = __webpack_public_path__ + "static/interUI-75cc72f97817e1f7320e1162c2ef8c1b.svg";